class ShopifyButtonEnhancer {
  constructor(buttonClass, priceClass) {
    this.buttonClass = buttonClass;
    this.priceClass = priceClass;
    this.init();
  }

  init() {
    window.addEventListener('load', () => this.updateButtons());
  }

  updateButtons() {
    const priceElement = document.querySelector(`.${this.priceClass}`);
    const priceText = priceElement ? priceElement.textContent.trim() : null;

    if (!priceText) {
      console.warn(`Nu s-a găsit elementul cu clasa "${this.priceClass}".`);
    }

    const buttons = document.querySelectorAll(`.${this.buttonClass}`);
    if (buttons.length === 0) {
      console.warn(`Nu s-au găsit butoane cu clasa "${this.buttonClass}".`);
      return;
    }

    buttons.forEach((button, index) => {
      const originalText = button.textContent.trim();
      const newText = priceText ? `${originalText} ${priceText}` : originalText;

      button.textContent = newText;
      console.log(`Buton ${index + 1}: ${newText}`);
    });
  }
}

// Inițializare
new ShopifyButtonEnhancer(
  'shopify-payment-button__button--unbranded',
  'm-price-item'
);
